module.exports = __webpack_public_path__ + "img/features-img2.b5cef3df.png";